import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useSwipeable} from 'react-swipeable';

import currency from '../../../common/util/currency';
import GlobalConst from '../../../common/global-const';

import {Container, Offcanvas, Button, Row, Col} from 'react-bootstrap';

import * as IconFi from 'react-icons/fi';

const OffcanvasTickets = props => {
    const navigate = useNavigate()

    const data = props.data;

    // --------------------------------------------------------------------------------------------------- show and hide

    const handlePopstate = () => {

        if (document.querySelectorAll('.offcanvas').length < 2)
            window.removeEventListener('popstate', handlePopstate)

        props.onHide()

    }

    const onShowHandler = () => {

        document.querySelector('#offcanvasTickets > div').style.paddingRight = document.querySelector('body').style.paddingRight

        navigate('#offcanvasTickets')
        window.addEventListener('popstate',  handlePopstate);

    }

    const onHideHandler = () => {

        navigate(-1)

    }

    const swipe = useSwipeable({
        onSwiping: (data) => {

            if (data.deltaY > 0 && data.deltaY < data.event.target.closest('.offcanvas').offsetHeight)
                data.event.target.closest('.offcanvas').style.transform = `translateY(${data.deltaY}px)`

        },
        onSwiped: (data) => {

            if (data.velocity > .9) {

                data.event.target.closest('.offcanvas').style.transform = `translateY(100%)`
                onHideHandler()

            } else {

                let h = data.event.target.closest('.offcanvas').offsetHeight
                let translateY = getComputedStyle(data.event.target.closest('.offcanvas')).transform.match(/matrix.*\((.+)\)/)[1].split(', ')[5]

                if (translateY > h / 2) {

                    data.event.target.closest('.offcanvas').style.transform = `translateY(100%)`
                    onHideHandler()

                } else data.event.target.closest('.offcanvas').style.transform = ''
            }

        }
    });

    // -----------------------------------------------------------------------------------------------------------------

    // از کلاس fixed-bottom استفاده شد تا padding-right ایجاد گردد
    return (
        <Offcanvas id="offcanvasTickets" {...props} placement="bottom" onHide={onHideHandler} onShow={onShowHandler} className="ltr fixed-bottom">
            {
                data ? (
                    <div className="w-100vw">
                        <Container fluid="lg" className="px-0 rtl">
                            <Offcanvas.Header className="position-sticky top-0 flex-column flex-md-row">
                                <Button variant="link" className="pt-1 pb-3 align-self-stretch d-flex justify-content-center d-md-none minimize" onClick={onHideHandler} onTouchStart={e => e.target.closest('.offcanvas').classList.add('swiping')} onTouchEnd={e => e.target.closest('.offcanvas').classList.remove('swiping')} {...swipe}/>
                                <Offcanvas.Title>بلیط</Offcanvas.Title>
                                <Button variant="link" className="text-reset border-0 btn-icon d-none d-md-inline-flex" aria-label="Close" onClick={onHideHandler}><IconFi.FiX size={24} className="m-2 sw-1"/></Button>
                            </Offcanvas.Header>
                            <Offcanvas.Body className="overflow-visible">
                                <Row className="gx-3 gy-2">
                                    <Col xs={12}>
                                        <div className="h4 fw-normal mb-1">{data.name}</div>
                                        <div className="fs-5 text-muted">{data.reserve_date}<span className="ms-2">ساعت </span>{data.reserve_time} تا {data.endTime}</div>
                                        <div>{data.type === 'normal' ? `${data.reserve_count} بلیط ${data.typeTitle}` : `${data.reserve_count} ${data.typeTitle}`}</div>
                                    </Col>
                                    {
                                        data.paid ? (
                                            <>
                                                <Col xs={12} className="fw-bold pt-3 text-success">پرداخت شده</Col>
                                                <Col xs={12}>مبلغ پرداخت شده {currency(data.total_price)} {GlobalConst.currency} می باشد.</Col>
                                            </>
                                        ) : (
                                            <>
                                                <Col xs={12} className="fw-bold pt-3 text-danger">پرداخت نشده</Col>
                                                <Col xs={12}>مبلغ قابل پرداخت {currency(data.total_price)} {GlobalConst.currency} می باشد.</Col>
                                            </>
                                        )
                                    }
                                </Row>
                            </Offcanvas.Body>
                        </Container>
                    </div>
                ) : (
                    <></>
                )
            }
        </Offcanvas>
    )
}

export default OffcanvasTickets;